import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const methods = [{
  image: 'https://cdn.magicpatterns.com/uploads/5vgAzxr8tU9ZdjkM9a53ur/ChatGPT_Image_14_jun_2026,_02_59_44.webp',
  tomo: 'Tomo 2 · Sílabas',
  title: 'El Tren de las Sílabas',
  color: 'bg-slate-50 border-slate-100',
  desc: 'Una forma visual de unir sonidos y transformar letras aisladas en sílabas reales.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/97Ss1qi9DnVM4UNWDFCXTK/ChatGPT_Image_14_jun_2026,_03_01_38.webp',
  tomo: 'Tomo 3 · Primeras Palabras',
  title: 'Las Tarjetas Mágicas',
  color: 'bg-amber-50 border-amber-100',
  desc: 'Palabras simples que permiten construir confianza desde el primer avance.'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/o3ZXMWqgoeqRVTjYQ3vn6A/ChatGPT_Image_14_jun_2026,_03_03_23.webp',
  tomo: 'Tomo 4 · Primeras Frases',
  title: 'La Escalera de Lectura',
  color: 'bg-emerald-50/50 border-emerald-100',
  desc: 'Un sistema progresivo para pasar de palabras aisladas a frases completas sin miedo.'
}];
export function VisualMethods() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-332">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-333">
        <div className="text-center mb-8" data-id="element-334">
          <span className="text-gold font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-335">
            Mirá adentro del sistema
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-navy" data-id="element-336">
            Un vistazo a los Métodos Visuales
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-337">
            Herramientas simples que los niños pueden entender desde el primer
            día.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-338">
          {methods.map((m, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`rounded-2xl border ${m.color} flex flex-col overflow-hidden`} data-id="element-339">
              <div className="p-3 pb-0" data-id="element-340">
                <div className="rounded-xl overflow-hidden bg-white border border-slate-100 shadow-sm" data-id="element-341">
                  <img src={m.image} alt={`${m.title} — ${m.tomo}, método visual de Mis Primeras Lecturas`} width={1240} height={1240} sizes="(max-width: 768px) 100vw, 33vw" className="w-full h-auto block" loading="lazy" decoding="async" data-id="element-342" />
                </div>
              </div>
              <div className="p-6 pt-5 flex flex-col flex-1" data-id="element-343">
                <div className="text-xs font-bold text-slate-500 uppercase tracking-wide mb-1.5" data-id="element-344">
                  {m.tomo}
                </div>
                <h3 className="text-xl font-bold text-navy mb-3" data-id="element-345">{m.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed" data-id="element-346">
                  {m.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}